import { render, staticRenderFns } from "./NoNumberToMsindn.vue?vue&type=template&id=e6bafe32&scoped=true&"
import script from "./NoNumberToMsindn.vue?vue&type=script&lang=js&"
export * from "./NoNumberToMsindn.vue?vue&type=script&lang=js&"
import style0 from "./NoNumberToMsindn.vue?vue&type=style&index=0&id=e6bafe32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bafe32",
  null
  
)

export default component.exports